import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '../../../../../assets/images/likeicon01.png'
import _imports_1 from '../../../../../assets/images/likeicon02.png'
import _imports_2 from '../../../../../assets/images/likeicon03.png'
import _imports_3 from '../../../../../assets/images/likeicon04.png'


const _hoisted_1 = { class: "reaction_body" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "reaction"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  class: "tabs_view",
  id: "pr_reactions"
}
const _hoisted_8 = {
  key: 0,
  class: "error_txt"
}
const _hoisted_9 = { class: "reaction" }
const _hoisted_10 = {
  key: 0,
  src: _imports_0
}
const _hoisted_11 = {
  key: 1,
  src: _imports_1
}
const _hoisted_12 = {
  key: 2,
  src: _imports_2
}
const _hoisted_13 = {
  key: 3,
  src: _imports_3
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileAvatarComponent = _resolveComponent("ProfileAvatarComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactions, (tab, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["tab", _ctx.selectedReaction == tab.title ? 'active' : '']),
          onClick: ($event: any) => (_ctx.selectedReaction = tab.title),
          key: index
        }, [
          (tab.icon)
            ? (_openBlock(), _createElementBlock("figure", _hoisted_4, [
                _createElementVNode("img", {
                  src: _ctx.getImageUrl(tab.icon)
                }, null, 8, _hoisted_5)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, [
            (!tab.icon)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(tab.title), 1))
              : _createCommentVNode("", true),
            _createTextVNode(" (" + _toDisplayString(tab.count) + ") ", 1)
          ])
        ], 10, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (!_ctx.filterReactions.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, "No Reaction Yet"))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterReactions, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: item._id
        }, [
          _createVNode(_component_ProfileAvatarComponent, {
            badges: false,
            border: true,
            class: "small mr-10"
          }),
          _createElementVNode("h6", null, _toDisplayString(item.userFullName), 1),
          _createElementVNode("figure", _hoisted_9, [
            (item.reactionType == 'like')
              ? (_openBlock(), _createElementBlock("img", _hoisted_10))
              : _createCommentVNode("", true),
            (item.reactionType == 'heart')
              ? (_openBlock(), _createElementBlock("img", _hoisted_11))
              : _createCommentVNode("", true),
            (item.reactionType == 'appreciated')
              ? (_openBlock(), _createElementBlock("img", _hoisted_12))
              : _createCommentVNode("", true),
            (item.reactionType == 'kiss')
              ? (_openBlock(), _createElementBlock("img", _hoisted_13))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
}